import React, {useEffect} from "react";
import {useLocation,useParams,useHistory} from "react-router-dom";
import "./NotificationCenter.scss";
import {LogRequest} from "../../Services";

function NotificationCenter() {

    //hook
    const location = useLocation();
    const { id,page} = useParams();
    const history= useHistory();


    useEffect(()=>{
        redirect(page);
    },[])

    const redirect = (page)=>{
        switch (page) {
            case 'scan':
                //Log
                LogRequest({type:"Notification",meta:JSON.stringify({id,page})})
                history.push('/scan');
                break;
            case 'report':
                //Log
                LogRequest({type:"Notification",meta:JSON.stringify({id,page})})
                history.push('/reward');
                break;
            case 'store':
                //Log
                LogRequest({type:"Notification",meta:JSON.stringify({id,page})})
                history.push('/store');
                break;
            case 'home':
                //Log
                LogRequest({type:"Notification",meta:JSON.stringify({id,page})})
                history.push('/home');
                break;
            default:
                LogRequest({type:"Notification",meta:JSON.stringify({id,page})})
                history.push(`/online-store-product/${page}/${id}`);
                break;
        }
    }

    return(
        <div className="notification-center-container">
            <img src="/other/logo.png" alt=""/>
            <span>... در حال هدایت</span>
        </div>
    )
}

export {NotificationCenter};
